/* ============================================
   NOOR THEME — JavaScript (vanilla, no deps)
   ============================================ */

(function () {
  'use strict';

  var Theme = window.Theme || {};
  Theme.routes  = Theme.routes  || {};
  Theme.shop    = Theme.shop    || {};
  Theme.strings = Theme.strings || {};

  var designMode = !!(window.Shopify && window.Shopify.designMode);

  // -------- Utilities --------
  function $(sel, scope)  { return (scope || document).querySelector(sel); }
  function $$(sel, scope) { return Array.prototype.slice.call((scope || document).querySelectorAll(sel)); }

  function formatMoney(cents) {
    try {
      return new Intl.NumberFormat(Theme.shop.locale || 'en', {
        style: 'currency',
        currency: Theme.shop.currency || 'USD'
      }).format((cents || 0) / 100);
    } catch (e) {
      return '$' + ((cents || 0) / 100).toFixed(2);
    }
  }

  function showToast(msg) {
    var t = $('.toast'); if (!t) return;
    t.textContent = msg; t.hidden = false;
    clearTimeout(t._timer);
    t._timer = setTimeout(function () { t.hidden = true; }, 2200);
  }

  // -------- Accordions (Benefits + How it works) --------
  function initAccordions(scope) {
    $$('[data-acc-item]', scope).forEach(function (item) {
      var head = $('[data-acc-head]', item);
      if (!head) return;
      if (!head._bound) {
        head.addEventListener('click', function () {
          var wrap = item.parentElement;
          var wasOpen = item.classList.contains('is-open');
          $$('[data-acc-item]', wrap).forEach(function (sib) { sib.classList.remove('is-open'); });
          if (!wasOpen) item.classList.add('is-open');
        });
        head._bound = true;
      }
    });
  }

  // -------- FAQ (independent items, multi-open) --------
  function initFaq(scope) {
    $$('[data-faq-item]', scope).forEach(function (item) {
      if (item._bound) return;
      item.addEventListener('click', function () { item.classList.toggle('is-open'); });
      item._bound = true;
    });
  }

  // -------- Mobile menu --------
  function initMobileMenu(scope) {
    var burger  = $('[data-menu-toggle]', scope);
    var drawer  = $('[data-mobile-menu]', scope);
    var overlay = $('[data-menu-overlay]', scope);
    var closeBtn = $('[data-menu-close]', scope);
    if (!burger || !drawer) return;
    if (burger._bound) return;

    function open()  { drawer.classList.add('is-open'); if (overlay) overlay.classList.add('is-open'); document.body.classList.add('menu-open'); burger.setAttribute('aria-expanded', 'true'); }
    function close() { drawer.classList.remove('is-open'); if (overlay) overlay.classList.remove('is-open'); document.body.classList.remove('menu-open'); burger.setAttribute('aria-expanded', 'false'); }

    burger.addEventListener('click', open);
    if (closeBtn) closeBtn.addEventListener('click', close);
    if (overlay) overlay.addEventListener('click', close);
    burger._bound = true;
  }

  // -------- Sticky ATC visibility --------
  function initStickyAtc() {
    var atc = $('[data-sticky-atc]');
    if (!atc) return;
    function onScroll() {
      if (window.scrollY > 700) atc.classList.add('is-visible');
      else atc.classList.remove('is-visible');
    }
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  // -------- Cart drawer open/close --------
  function openCart()  {
    if (designMode) return; // never open in customizer iframe
    var d = $('[data-cart-drawer]'); if (!d) return;
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-open');
  }
  function closeCart() {
    var d = $('[data-cart-drawer]'); if (!d) return;
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  }

  // Force-close on page load (defensive — handles any stale state)
  document.addEventListener('DOMContentLoaded', function () {
    var d = $('[data-cart-drawer]');
    if (d) d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-open');
  });

  function initCartDrawerEvents() {
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cart-open]')) { e.preventDefault(); openCart(); refreshCart(); }
      if (e.target.closest('[data-cart-drawer-close]')) { e.preventDefault(); closeCart(); }
    });
  }

  // -------- Cart fetch + render --------
  function fetchCart() {
    return fetch(Theme.routes.cart_url + '.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function refreshCart() {
    return fetchCart().then(function (cart) {
      var subtotalEl = $('[data-cart-subtotal]');
      if (subtotalEl) subtotalEl.textContent = formatMoney(cart.total_price);

      $$('[data-cart-count]').forEach(function (el) {
        el.textContent = cart.item_count;
        el.hidden = cart.item_count === 0;
      });

      renderCartItems(cart);
      return cart;
    });
  }

  function renderCartItems(cart) {
    var body = $('[data-cart-drawer-body]');
    var foot = $('[data-cart-drawer-foot]');
    if (!body) return;

    if (cart.item_count === 0) {
      body.innerHTML = '<p class="cart-empty">Your cart is empty.</p>';
      if (foot) {
        foot.innerHTML = '<a href="' + (Theme.routes.root_url || '/') + 'products" class="btn btn--primary btn--full">Shop the kit</a>';
      }
      return;
    }

    var rows = cart.items.map(function (item) {
      var img = item.image
        ? '<img src="' + item.image + '&width=160" alt="' + escapeHtml(item.product_title) + '" width="80" height="80" loading="lazy">'
        : '<div class="placeholder-image" aria-hidden="true"></div>';
      var variantLine = (item.variant_title && item.variant_title !== 'Default Title')
        ? '<small>' + escapeHtml(item.variant_title) + '</small>' : '';
      return ''
        + '<li class="cart-line" data-line-key="' + item.key + '">'
        +   '<div class="cart-line__img">' + img + '</div>'
        +   '<div class="cart-line__info">'
        +     '<a href="' + item.url + '">' + escapeHtml(item.product_title) + '</a>'
        +     variantLine
        +     '<div class="cart-line__qty">'
        +       '<button type="button" data-qty-minus aria-label="Decrease">&minus;</button>'
        +       '<span data-qty-display>' + item.quantity + '</span>'
        +       '<button type="button" data-qty-plus aria-label="Increase">+</button>'
        +       '<button type="button" class="cart-line__remove" data-cart-remove aria-label="Remove">Remove</button>'
        +     '</div>'
        +   '</div>'
        +   '<div class="cart-line__price">' + formatMoney(item.final_line_price) + '</div>'
        + '</li>';
    }).join('');

    body.innerHTML = '<ul class="cart-drawer__items">' + rows + '</ul>';

    if (foot) {
      foot.innerHTML = ''
        + '<div class="cart-drawer__subtotal"><span>Subtotal</span><strong data-cart-subtotal>' + formatMoney(cart.total_price) + '</strong></div>'
        + '<a href="' + Theme.routes.cart_url + '" class="btn btn--ghost btn--full">View cart</a>'
        + '<a href="/checkout" class="btn btn--primary btn--full">Checkout</a>';
    }
  }

  function escapeHtml(str) {
    return String(str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  // -------- Add to cart (AJAX, with customizer bypass) --------
  function initProductForms() {
    document.addEventListener('submit', function (e) {
      var form = e.target.closest('form[action*="/cart/add"]');
      if (!form) return;
      if (designMode) return; // let native submit run inside the customizer iframe

      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var original = btn ? btn.innerHTML : '';
      if (btn) { btn.disabled = true; btn.innerHTML = 'Adding…'; }

      var formData = new FormData(form);

      fetch(Theme.routes.cart_add_url, {
        method: 'POST',
        headers: { 'Accept': 'application/javascript', 'X-Requested-With': 'XMLHttpRequest' },
        body: formData
      })
        .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
        .then(function (res) {
          if (!res.ok) throw new Error((res.data && (res.data.description || res.data.message)) || 'Cart error');
          showToast(Theme.strings.addedToCart || 'Added to cart');
          return refreshCart().then(openCart);
        })
        .catch(function (err) {
          console.error(err);
          showToast(Theme.strings.cartError || 'Could not add to cart');
        })
        .finally(function () {
          if (btn) { btn.disabled = false; btn.innerHTML = original; }
        });
    });
  }

  // -------- Quantity steppers + remove (uses item.key) --------
  function initCartLineActions() {
    document.addEventListener('click', function (e) {
      var line = e.target.closest('[data-line-key]');
      if (!line) return;
      var key = line.getAttribute('data-line-key');
      var display = $('[data-qty-display]', line);
      var qty = display ? parseInt(display.textContent, 10) || 0 : 0;

      if (e.target.matches('[data-qty-plus]'))  qty += 1;
      else if (e.target.matches('[data-qty-minus]')) qty = Math.max(0, qty - 1);
      else if (e.target.matches('[data-cart-remove]')) qty = 0;
      else return;

      changeCart(key, qty);
    });
  }

  function changeCart(key, qty) {
    return fetch(Theme.routes.cart_change_url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return refreshCart(); });
  }

  // -------- Smooth in-page anchor scroll --------
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href^="#"]');
      if (!a) return;
      var href = a.getAttribute('href');
      if (!href || href === '#' || href.length < 2) return;
      var target = document.querySelector(href);
      if (!target) return;
      e.preventDefault();
      var top = target.getBoundingClientRect().top + window.scrollY - 80;
      window.scrollTo({ top: top, behavior: 'smooth' });
    });
  }

  // -------- Variant picker (for main-product) --------
  function initVariantPickers(scope) {
    $$('form[data-product-form]', scope).forEach(function (form) {
      if (form._variantBound) return;
      var data;
      try { data = JSON.parse(form.getAttribute('data-product-json') || 'null'); } catch (e) { data = null; }
      if (!data || !data.variants) return;

      var variantInput = form.querySelector('[data-variant-id]');
      var priceEl      = $('[data-product-price]');
      var submitBtn    = form.querySelector('[type="submit"]');

      form.addEventListener('change', function (e) {
        if (!e.target.matches('input[type="radio"][name^="options["], select[name^="options["]')) return;

        var selected = {};
        Array.prototype.slice.call(form.querySelectorAll('input[type="radio"]:checked, select[name^="options["]'))
          .forEach(function (el) {
            var m = el.name.match(/options\[(.+)\]/);
            if (m) selected[m[1]] = el.value;
          });

        var match = data.variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === selected[data.options[i]]; });
        });
        if (!match) return;

        if (variantInput) variantInput.value = match.id;
        if (priceEl) priceEl.textContent = formatMoney(match.price);
        if (submitBtn) {
          submitBtn.disabled = !match.available;
          submitBtn.textContent = match.available ? 'Add to cart — ' + formatMoney(match.price) : (Theme.strings.soldOut || 'Sold out');
        }
      });

      form._variantBound = true;
    });
  }

  // -------- Loved-by tabs --------
  function initLovedByTabs(scope) {
    $$('[data-loved-by]', scope).forEach(function (root) {
      if (root._lovedBound) return;
      var tabs = $$('[data-loved-tab]', root);
      var panels = $$('[data-loved-panel]', root);
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var idx = tab.getAttribute('data-loved-tab');
          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          panels.forEach(function (p) {
            if (p.getAttribute('data-loved-panel') === idx) {
              p.classList.add('is-active');
              p.hidden = false;
            } else {
              p.classList.remove('is-active');
              p.hidden = true;
            }
          });
        });
      });
      root._lovedBound = true;
    });
  }

  // -------- Photo gallery (swipe) --------
  function initGalleries(scope) {
    $$('[data-gallery]', scope).forEach(function (root) {
      if (root._galleryBound) return;
      var track = $('[data-gallery-track]', root);
      if (!track) return;
      var slides = $$('.gallery__slide', track);
      var dots   = $$('[data-gallery-dot]', root);
      var prev   = $('[data-gallery-prev]', root);
      var next   = $('[data-gallery-next]', root);
      if (slides.length === 0) return;

      function activeIndex() {
        var center = track.scrollLeft + track.clientWidth / 2;
        var best = 0, bestDist = Infinity;
        slides.forEach(function (s, i) {
          var mid = s.offsetLeft + s.offsetWidth / 2;
          var d = Math.abs(mid - center);
          if (d < bestDist) { bestDist = d; best = i; }
        });
        return best;
      }

      function scrollToIndex(i) {
        var s = slides[Math.max(0, Math.min(slides.length - 1, i))];
        if (!s) return;
        track.scrollTo({ left: s.offsetLeft - (track.clientWidth - s.offsetWidth) / 2, behavior: 'smooth' });
      }

      function sync() {
        var idx = activeIndex();
        dots.forEach(function (d, i) { d.classList.toggle('is-active', i === idx); });
        if (prev) prev.disabled = track.scrollLeft <= 2;
        if (next) next.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
      }

      if (prev) prev.addEventListener('click', function () { scrollToIndex(activeIndex() - 1); });
      if (next) next.addEventListener('click', function () { scrollToIndex(activeIndex() + 1); });
      dots.forEach(function (d) {
        d.addEventListener('click', function () {
          scrollToIndex(parseInt(d.getAttribute('data-gallery-dot'), 10) || 0);
        });
      });

      var raf;
      track.addEventListener('scroll', function () {
        if (raf) cancelAnimationFrame(raf);
        raf = requestAnimationFrame(sync);
      }, { passive: true });

      sync();
      root._galleryBound = true;
    });
  }

  // -------- Init everything --------
  function initAll(scope) {
    initAccordions(scope || document);
    initFaq(scope || document);
    initMobileMenu(scope || document);
    initVariantPickers(scope || document);
    initLovedByTabs(scope || document);
    initGalleries(scope || document);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initStickyAtc();
    initCartDrawerEvents();
    initProductForms();
    initCartLineActions();
    initSmoothScroll();
    refreshCart();
  });

  // Re-init when a section reloads in the customizer
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });

})();
